(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name webAgro1App.PlantiosService
   * @description
   * # PlantiosService
   * Factory in the webAgro1App.
   */
  angular
    .module('webAgro1App')
    .factory('PlantiosService', PlantiosService);

  PlantiosService.$inject = [
    '$http',
    '$rootScope'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function PlantiosService($http, $rootScope) {
    //////////////////////////////////////////
    // Service data

    //////////////////////////////////////////
    // Service object declaration
    return {
      list,
      getStatusPlantioGlebas,
      get,
      delete: deleteFn,
      getPlantioSimples,
      updatePlantioSimples,
      deletePlantioSimples,
      reprocess,
      inactivatePreviousSafras,
      updatePeriodo
    };

    //////////////////////////////////////////
    // Function declarations

    // eslint-disable-next-line complexity
    function getFilters(filters) {
      return !filters ? {} : {
        data_inicial: filters.dataInicial || null,
        data_final: filters.dataFinal || null,
        page: filters.page || null,
        gleba: (filters.gleba || {}).id || null,
        atividade: (filters.cultura || {}).id || null,
        estadio: (filters.estadio || {}).id || null,
        grupo_insumo: (filters.grupoInsumo || {}).id || null,
        operacao: $rootScope.parametros.operacao_semeadura.id,
        epoca: (filters.epoca || {}).codigo,
        status: filters.status || null
      };
    }

    function list(filters) {
      const params = getFilters(filters);

      return $http.get(`${SERVER}v1/aplicacoes/simple`, { params: params });
    }

    function getStatusPlantioGlebas(filters) {
      return $http.get(`${SERVER + API_VERSION}aplicacoes_status_glebas`, { params: getFilters(filters) });
    }

    function get(id) {
      return $http.get(`${SERVER}v1/aplicacoes/${ id}`);
    }

    function deleteFn(id) {
      return $http.delete(`${SERVER}v1/aplicacoes/${ id}`);
    }

    function getPlantioSimples({ gleba, atividade, insumo, safra, onlyActive }) {
      if (_.isObject(safra)) {
        safra = safra.id;
      }

      if (_.isObject(gleba)) {
        gleba = gleba.id;
      }

      return $http.get(`${SERVER}v1/plantios`, {
        params: { gleba, atividade, insumo, safra, no_paginate: true, only_active: onlyActive }
      });
    }

    function reprocess() {
      return $http.post(`${SERVER}v1/plantios/reprocess`);
    }

    function inactivatePreviousSafras() {
      return $http.post(`${SERVER}v1/plantios/inactivate_previous_safras`);
    }

    //eslint-disable-next-line
    function updatePlantioSimples({ cultivar, atividade, periodo, area, plantio, dataInicio, dataFim, dataEncerramento, areaAtiva }) {
      const data = {
        plantio: {
          insumo_id: (cultivar || {}).item_id,
          insumo_tipo: (cultivar || {}).tipo_item,
          atividade_id: (atividade || {}).id,
          periodo_id: (periodo || {}).codigo,
          area,
          data_encerramento: dataEncerramento,
          data_inicio: dataInicio,
          data_fim: dataFim,
          area_ativa: areaAtiva
        }
      };
      return $http.patch(`${SERVER}v1/plantios/${plantio}`, data);
    }

    function deletePlantioSimples(id) {
      return $http.delete(`${SERVER}v1/plantios/${id}`);
    }

    function updatePeriodo(plantiosId, periodoId) {
      return $http.patch(`${SERVER}v1/plantios/periodos`, { plantios_id: plantiosId, periodo_id: periodoId });
    }
  }
}());
